import React, { useState, useEffect } from 'react';
import { Provider } from '@active/react-utils/i18n/LocaleContext';
import { CommonPropsProvider } from './CommonPropsContext';
import { loadI18nMsg } from './commonUtils';
import DEFAULT_MESSAGES from '../../i18n/en_US.json';

const DEFAULT_LOCALE = 'en_US';

const injectI18n = WrappedComponent => ({ locale = DEFAULT_LOCALE, ...rest }) => {
  const [ messages, setMessages ] = useState(DEFAULT_MESSAGES);

  useEffect(() => {
    loadI18nMsg(locale, msg => setMessages(msg));
  }, [ locale ]);

  return (
    <Provider locales={messages} >
      <CommonPropsProvider value={{ locale }}>
        <WrappedComponent {...rest} />
      </CommonPropsProvider>
    </Provider>
  );
};

export default injectI18n;
